import type { SortEvent } from "react-sortable-hoc";

export const isTouchEvent = (event: SortEvent) =>
  event.type.toLowerCase().includes("touch");
